module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "sec-9"
    }
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "Savior"
    }
  }, [_c('h1', {
    staticClass: "chapter2",
    attrs: {
      "id": "pz9-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#ba_02",
      "id": "ab_02"
    }
  }, [_c('b', [_vm._v("Savior")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz9-3"
    }
  }, [_vm._v("Not by works of righteousness which we have done, but according to His mercy He saved us, through the washing of regeneration and renewing of the Holy Spirit,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz9-4"
    }
  }, [_vm._v("whom He poured out on us abundantly through Jesus Christ our Savior.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz9-6"
    }
  }, [_c('em', [_vm._v("Titus 3:5, 6")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz9-7"
    }
  }, [_vm._v("And we have seen and testify that the Father has sent the Son as Savior of the world.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz9-8"
    }
  }, [_c('em', [_vm._v("I John 4:14")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz9-9"
    }
  }, [_vm._v("And my spirit has rejoiced in God my Savior.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz9-10"
    }
  }, [_c('em', [_vm._v("Luke 1:47")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz9-11"
    }
  }, [_vm._v("For we ourselves have heard Him and we know that this is indeed the Christ, the Savior of the world.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz9-12"
    }
  }, [_c('em', [_vm._v("John 4:42b")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz9-13"
    }
  }, [_vm._v("For the Son of Man has come to seek and to save that which was lost.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz9-14"
    }
  }, [_c('em', [_vm._v("Luke 19:10")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz10-1"
    }
  }, [_vm._v("For God so loved the world that He gave His only begotten Son, that whoever believes in Him should not perish but have everlasting life.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "AN8"
    }
  }, [_c('em', [_vm._v("John 3:16")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz10-2"
    }
  }, [_vm._v("Being justified freely by His grace through the redemption that is in Christ Jesus,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz10-3"
    }
  }, [_vm._v("whom God set forth as a propitiation by His blood, through faith, to demonstrate His righteousness, because in His forbearance God had passed over the sins that were previously committed.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz10-4"
    }
  }, [_c('em', [_vm._v("Romans 3:24, 25")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz10-5"
    }
  }, [_vm._v("But God, who is rich in mercy, because of His great love with which He loved us,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz10-6"
    }
  }, [_vm._v("even when we were dead in trespasses, made us alive together with Christ (by grace you have been saved).")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz10-7"
    }
  }, [_c('em', [_vm._v("Ephesians 2:4, 5")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz10-8"
    }
  }, [_vm._v("Most assuredly, I say to you, he who believes in Me has everlasting life.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz10-9"
    }
  }, [_c('em', [_vm._v("John 6:47")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz11-1"
    }
  }, [_vm._v("For by grace you have been saved through faith, and that not of yourselves; it is the gift of God,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz11-2"
    }
  }, [_vm._v("not of works, lest anyone should boast.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz11-3"
    }
  }, [_c('em', [_vm._v("Ephesians 2:8, 9")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz11-4"
    }
  }, [_vm._v("That if you confess with your mouth the Lord Jesus and believe in your heart that God has raised Him from the dead, you will be saved.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "AO5"
    }
  }, [_c('em', [_vm._v("Romans 10:9")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz11-5"
    }
  }, [_vm._v("Therefore, if anyone is in Christ, he is a new creation; old things have passed away; behold, all things have become new.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz11-6"
    }
  }, [_c('em', [_vm._v("II Corinthians 5:17")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz11-7"
    }
  }, [_vm._v("Who has saved us and called us with a holy calling, not according to our works, but according to His own purpose and grace which was given to us in Christ Jesus before time began.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "ASq"
    }
  }, [_c('em', [_vm._v("II Timothy 1:9")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz11-8"
    }
  }, [_vm._v("Nevertheless He saved them for His name’s sake, that He might make His mighty power known.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz11-9"
    }
  }, [_c('em', [_vm._v("Psalm 106:8")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8004370","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter02.vue
// module id = 75
// module chunks = 0